import * as request from '../types/request'

export const initialState = {
    loading: false
}

export const requestReducer = (state = initialState, action = { type: '' }) => {
    switch (action.type) {
        case request.LOADING:
            return {
                ...state,
                loading: action.value
            }
        case request.RESET:
            return initialState
        default:
            return state
    }
}
